import React from 'react';
import graphql from "babel-plugin-relay/macro";
import NewModal from "../../../components/common/modals/NewModal";
import {
    createLocationOptions,
    createOptions,
    yesNoUnknownOptions
} from "../../../helpers/utils";
import {useFragment} from "react-relay";
import {locationsDropdown} from "../../locations/LocationFragments";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import {contractLineOfService} from "../../contracts/ContractLineOfService/ContractLinesOfServiceFragments";
import HorizontalFormCheck from "../../../components/common/horizontal-form-inputs/HorizontalFormCheck";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";

const NewPractitionerLocationModal = ({showModal, onClose, allLocations, practitionerId, availableLinesOfService}) => {
    const mutation = graphql`
    mutation NewPractitionerLocationModalMutation($practitionerId: ID!, $locationId: ID!,
        $legalContractLineOfServiceId: ID!, 
        $showInDirectory: Boolean!, $acceptingNewPatients: YesNoUnknown!, $providesTelehealth: YesNoUnknown!, 
        $providesOfficeVisits: YesNoUnknown!, $providesHomeVisits: YesNoUnknown!, $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
        practitionerLocation {
            create(input: {practitionerId: $practitionerId, locationId: $locationId, legalContractLineOfServiceId: $legalContractLineOfServiceId,
                showInDirectory: $showInDirectory, providesTelehealth: $providesTelehealth, acceptingNewPatients: $acceptingNewPatients,
            providesHomeVisits: $providesHomeVisits, providesOfficeVisits: $providesOfficeVisits, effectiveFrom: $effectiveFrom,
            effectiveTo: $effectiveTo}) {
                practitionerLocation {
                    id
                }
            }
        }
    }`
    const locations = createLocationOptions(useFragment(locationsDropdown, allLocations));
    const linesOfService = useFragment(contractLineOfService, availableLinesOfService);
    const legalContractLineOfServiceOptions = createOptions(linesOfService, "id", "lineOfService.name");
    const defaultValues = {
        ...newBandDefaultValues,
        practitionerId: practitionerId,
        locationId: '',
        legalContractLineOfServiceId: '',
        showInDirectory: true,
    }
    const schema = bandedSchema.shape({
        locationId: yup.string().required("Location is required"),
        legalContractLineOfServiceId: yup.string().required("Line of service is required"),
        showInDirectory: yup.boolean().required("Show in Directory is required"),
        acceptingNewPatients: yup.string().required("Accepting New Patients is required"),
        providesTelehealth: yup.string().required("Provides Telehealth is required"),
        providesHomeVisits: yup.string().required("Provides Home Visits is required"),
        providesOfficeVisits: yup.string().required("Provides Office Visits is required")
    });
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)});
    return (
        <NewModal showModal={showModal}
                  onClose={onClose}
                  mutation={mutation}
                  methods={methods}
                  title={"New Provider Location"}
                  returnedIdKey={"practitionerLocation.create.practitionerLocation.id"}
                  redirectUrl={"/practitioner-locations/"}
        >
            <HorizontalFormSelect options={locations} controlId={"locationId"} label={"Location"} />
            <HorizontalFormSelect options={legalContractLineOfServiceOptions} controlId={"legalContractLineOfServiceId"} label={"Line of Service"} />
            <HorizontalFormCheck controlId={"showInDirectory"} label={"Show In Directory?"} />
            <HorizontalFormSelect options={yesNoUnknownOptions} controlId={"acceptingNewPatients"} label={"Accepting New Patients?"} />
            <HorizontalFormSelect options={yesNoUnknownOptions} controlId={"providesTelehealth"} label={"Provides Telehealth?"} />
            <HorizontalFormSelect options={yesNoUnknownOptions} controlId={"providesOfficeVisits"} label={"Provides Office Visits?"} />
            <HorizontalFormSelect options={yesNoUnknownOptions} controlId={"providesHomeVisits"} label={"Provides Home Visits?"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
            
        </NewModal>
    )
}
export default NewPractitionerLocationModal